import { get } from 'lodash';

const root = state => get(state, 'KitchenItemState');

export const getKitchenItemsData = state =>
  get(root(state), 'kitchenItems', []);
export const getSubmitErrorData = state =>
  get(root(state), 'submitError', null);
export const getSubmittedData = state => get(root(state), 'submitted', false);
export const getItemsSubmitted = state =>
  get(root(state), 'itemsSubmitted', false);
export const getFetchKitchenItemsLoading = state =>
  get(root(state), 'fetchKitchenItemsLoading', false);
export const getFetchKitchenItemsError = state =>
  get(root(state), 'fetchKitchenItemsError', null);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenitems/state/selectors.js